import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'
import { COURSE_THEMES_API } from '../constants/course-themes-api'
import { CourseThemeInterface } from '../types/course-theme-interface'

function useCourseThemes() {
  const { data: themes } = useSWR<CourseThemeInterface[]>(() => COURSE_THEMES_API, baseFetcher)

  const preparedThemes = themes
    ?.filter(theme => !!theme.id)
    .sort((a, b) => {
      return a.id - b.id
    })

  return {
    themes: preparedThemes,
  }
}

export default useCourseThemes
